export default "https://d1e6s5z4lzmgxx.cloudfront.net/3cbd492b-c681-4587-ab2f-cab322978701/images/recording-icon.svg?b1d6bd8fb121f44fcd3fce6b82fa2d6d";